import { render, staticRenderFns } from "./zzym.vue?vue&type=template&id=00065017&scoped=true"
import script from "./zzym.vue?vue&type=script&lang=js"
export * from "./zzym.vue?vue&type=script&lang=js"
import style0 from "./zzym.vue?vue&type=style&index=0&id=00065017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00065017",
  null
  
)

export default component.exports